export default function ChapterDetail4(props) {
  document.title = props.text + " | Arisu";

	return (
    <>
      <p className="indent-8">
        It was the White Rabbit, trotting slowly back again, and looking anxiously
        about as it went, as if it had lost something; and she heard it muttering to
        itself “The Duchess! The Duchess! Oh my dear paws! Oh my fur and
        whiskers! She’ll get me executed, as sure as ferrets are ferrets! Where
        <i>can</i> I have dropped them, I wonder?” Alice guessed in a moment that
        it was looking for the fan and the pair of white kid gloves, and she very
        good-naturedly began hunting about for them, but they were nowhere to be
        seen—everything seemed to have changed since her swim in the pool, and
        the great hall, with the glass table and the little door, had vanished
        completely.
      </p>
      <p className="indent-8">
        Very soon the Rabbit noticed Alice, as she went hunting about, and called out
        to her in an angry tone, “Why, Mary Ann, what <i>are</i> you doing out
        here? Run home this moment, and fetch me a pair of gloves and a fan! Quick,
        now!” And Alice was so much frightened that she ran off at once in the
        direction it pointed to, without trying to explain the mistake it had made.
      </p>
      <p className="indent-8">
        “He took me for his housemaid,” she said to herself as she ran.
        “How surprised he’ll be when he finds out who I am! But I’d
        better take him his fan and gloves—that is, if I can find them.” As
        she said this, she came upon a neat little house, on the door of which was a
        bright brass plate with the name “W. RABBIT,” engraved upon it. She
        went in without knocking, and hurried upstairs, in great fear lest she should
        meet the real Mary Ann, and be turned out of the house before she had found the
        fan and gloves.
      </p>
      <p className="indent-8">
        “How queer it seems,” Alice said to herself, “to be going
        messages for a rabbit! I suppose Dinah’ll be sending me on messages
        next!” And she began fancying the sort of thing that would happen:
        “‘Miss Alice! Come here directly, and get ready for your
        walk!’ ‘Coming in a minute, nurse! But I’ve got to see that
        the mouse doesn’t get out.’ Only I don’t think,” Alice
        went on, “that they’d let Dinah stop in the house if it began
        ordering people about like that!”
      </p>
      <p className="indent-8">
        By this time she had found her way into a tidy little room with a table in the
        window, and on it (as she had hoped) a fan and two or three pairs of tiny white
        kid gloves: she took up the fan and a pair of the gloves, and was just going to
        leave the room, when her eye fell upon a little bottle that stood near the
        looking-glass. There was no label this time with the words “DRINK
        ME,” but nevertheless she uncorked it and put it to her lips. “I
        know <i>something</i> interesting is sure to happen,” she said to
        herself, “whenever I eat or drink anything; so I’ll just see what
        this bottle does. I do hope it’ll make me grow large again, for really
        I’m quite tired of being such a tiny little thing!”
      </p>
      <p className="indent-8">
        It did so indeed, and much sooner than she had expected: before she had drunk
        half the bottle, she found her head pressing against the ceiling, and had to
        stoop to save her neck from being broken. She hastily put down the bottle,
        saying to herself “That’s quite enough—I hope I shan’t
        grow any more—As it is, I can’t get out at the door—I do wish
        I hadn’t drunk quite so much!”
      </p>
      <p className="indent-8">
        Alas! it was too late to wish that! She went on growing, and growing, and very
        soon had to kneel down on the floor: in another minute there was not even room
        for this, and she tried the effect of lying down with one elbow against the
        door, and the other arm curled round her head. Still she went on growing, and,
        as a last resource, she put one arm out of the window, and one foot up the
        chimney, and said to herself “Now I can do no more, whatever happens.
        What <i>will</i> become of me?”
      </p>
      <p className="indent-8">
        Luckily for Alice, the little magic bottle had now had its full effect, and she
        grew no larger: still it was very uncomfortable, and, as there seemed to be no
        sort of chance of her ever getting out of the room again, no wonder she felt
        unhappy.
      </p>
      <p className="indent-8">
        “It was much pleasanter at home,” thought poor Alice, “when
        one wasn’t always growing larger and smaller, and being ordered about by
        mice and rabbits. I almost wish I hadn’t gone down that
        rabbit-hole—and yet—and yet—it’s rather curious, you
        know, this sort of life! I do wonder what <i>can</i> have happened to me! When
        I used to read fairy-tales, I fancied that kind of thing never happened, and
        now here I am in the middle of one! There ought to be a book written about me,
        that there ought! And when I grow up, I’ll write one—but I’m
        grown up now,” she added in a sorrowful tone; “at least
        there’s no room to grow up any more <i>here</i>.”
      </p>
      <p className="indent-8">
        “But then,” thought Alice, “shall I <i>never</i> get any
        older than I am now? That’ll be a comfort, one way—never to be an
        old woman—but then—always to have lessons to learn! Oh, I
        shouldn’t like <i>that!</i>”
      </p>
      <p className="indent-8">
        “Oh, you foolish Alice!” she answered herself. “How can you
        learn lessons in here? Why, there’s hardly room for <i>you</i>, and no
        room at all for any lesson-books!”
      </p>
      <p className="indent-8">
        And so she went on, taking first one side and then the other, and making quite
        a conversation of it altogether; but after a few minutes she heard a voice
        outside, and stopped to listen.
      </p>
      <p className="indent-8">
        “Mary Ann! Mary Ann!” said the voice. “Fetch me my gloves
        this moment!” Then came a little pattering of feet on the stairs. Alice
        knew it was the Rabbit coming to look for her, and she trembled till she shook
        the house, quite forgetting that she was now about a thousand times as large as
        the Rabbit, and had no reason to be afraid of it.
      </p>
      <p className="indent-8">
        Presently the Rabbit came up to the door, and tried to open it; but, as the
        door opened inwards, and Alice’s elbow was pressed hard against it, that
        attempt proved a failure. Alice heard it say to itself “Then I’ll
        go round and get in at the window.”
      </p>
      <p className="indent-8">
        “<i>That</i> you won’t!” thought Alice, and, after waiting
        till she fancied she heard the Rabbit just under the window, she suddenly
        spread out her hand, and made a snatch in the air. She did not get hold of
        anything, but she heard a little shriek and a fall, and a crash of broken
        glass, from which she concluded that it was just possible it had fallen into a
        cucumber-frame, or something of the sort.
      </p>
      <p className="indent-8">
        Next came an angry voice—the Rabbit’s—“Pat! Pat! Where
        are you?” And then a voice she had never heard before, “Sure then
        I’m here! Digging for apples, yer honour!”
      </p>
      <p className="indent-8">
        “Digging for apples, indeed!” said the Rabbit angrily. “Here!
        Come and help me out of <i>this!</i>” (Sounds of more broken glass.)
      </p>
      <p className="indent-8">
        “Now tell me, Pat, what’s that in the window?”
      </p>
      <p className="indent-8">
        “Sure, it’s an arm, yer honour!” (He pronounced it
        “arrum.”)
      </p>
      <p className="indent-8">
        “An arm, you goose! Who ever saw one that size? Why, it fills the whole
        window!”
      </p>
      <p className="indent-8">
        “Sure, it does, yer honour: but it’s an arm for all that.”
      </p>
      <p className="indent-8">
        “Well, it’s got no business there, at any rate: go and take it
        away!”
      </p>
      <p className="indent-8">
        There was a long silence after this, and Alice could only hear whispers now and
        then; such as, “Sure, I don’t like it, yer honour, at all, at
        all!” “Do as I tell you, you coward!” and at last she spread
        out her hand again, and made another snatch in the air. This time there were
        <i>two</i> little shrieks, and more sounds of broken glass. “What a
        number of cucumber-frames there must be!” thought Alice. “I wonder
        what they’ll do next! As for pulling me out of the window, I only wish
        they <i>could!</i> I’m sure <i>I</i> don’t want to stay in here any
        longer!”
      </p>
      <p className="indent-8">
        She waited for some time without hearing anything more: at last came a rumbling
        of little cartwheels, and the sound of a good many voices all talking together:
        she made out the words: “Where’s the other ladder?—Why, I
        hadn’t to bring but one; Bill’s got the other—Bill! fetch it
        here, lad!—Here, put ’em up at this corner—No, tie ’em
        together first—they don’t reach half high enough yet—Oh!
        they’ll do well enough; don’t be particular—Here, Bill! catch
        hold of this rope—Will the roof bear?—Mind that loose
        slate—Oh, it’s coming down! Heads below!” (a loud
        crash)—“Now, who did that?—It was Bill, I
        fancy—Who’s to go down the chimney?—Nay, <i>I</i>
        shan’t! <i>You</i> do it!—<i>That</i> I won’t,
        then!—Bill’s to go down—Here, Bill! the master says
        you’re to go down the chimney!”
      </p>
      <p className="indent-8">
        “Oh! So Bill’s got to come down the chimney, has he?” said
        Alice to herself. “Shy, they seem to put everything upon Bill! I
        wouldn’t be in Bill’s place for a good deal: this fireplace is
        narrow, to be sure; but I <i>think</i> I can kick a little!”
      </p>
      <p className="indent-8">
        She drew her foot as far down the chimney as she could, and waited till she
        heard a little animal (she couldn’t guess of what sort it was) scratching
        and scrambling about in the chimney close above her: then, saying to herself
        “This is Bill,” she gave one sharp kick, and waited to see what
        would happen next.
      </p>
      <p className="indent-8">
        The first thing she heard was a general chorus of “There goes
        Bill!” then the Rabbit’s voice along—“Catch him, you by
        the hedge!” then silence, and then another confusion of
        voices—“Hold up his head—Brandy now—Don’t choke
        him—How was it, old fellow? What happened to you? Tell us all about
        it!”
      </p>
      <p className="indent-8">
        Last came a little feeble, squeaking voice, (“That’s Bill,”
        thought Alice,) “Well, I hardly know—No more, thank ye; I’m
        better now—but I’m a deal too flustered to tell you—all I
        know is, something comes at me like a Jack-in-the-box, and up I goes like a
        sky-rocket!”
      </p>
      <p className="indent-8">
        “So you did, old fellow!” said the others.
      </p>
      <p className="indent-8">
        “We must burn the house down!” said the Rabbit’s voice; and
        Alice called out as loud as she could, “If you do, I’ll set Dinah
        at you!”
      </p>
      <p className="indent-8">
        There was a dead silence instantly, and Alice thought to herself, “I
        wonder what they <i>will</i> do next! If they had any sense, they’d take
        the roof off.” After a minute or two, they began moving about again, and
        Alice heard the Rabbit say, “A barrowful will do, to begin with.”
      </p>
      <p className="indent-8">
        “A barrowful of <i>what?</i>” thought Alice; but she had not long
        to doubt, for the next moment a shower of little pebbles came rattling in at
        the window, and some of them hit her in the face. “I’ll put a stop
        to this,” she said to herself, and shouted out, “You’d better
        not do that again!” which produced another dead silence.
      </p>
      <p className="indent-8">
        Alice noticed with some surprise that the pebbles were all turning into little
        cakes as they lay on the floor, and a bright idea came into her head. “If
        I eat one of these cakes,” she thought, “it’s sure to make
        <i>some</i> change in my size; and as it can’t possibly make me larger,
        it must make me smaller, I suppose.”
      </p>
      <p className="indent-8">
        So she swallowed one of the cakes, and was delighted to find that she began
        shrinking directly. As soon as she was small enough to get through the door,
        she ran out of the house, and found quite a crowd of little animals and birds
        waiting outside. The poor little Lizard, Bill, was in the middle, being held up
        by two guinea-pigs, who were giving it something out of a bottle. They all made
        a rush at Alice the moment she appeared; but she ran off as hard as she could,
        and soon found herself safe in a thick wood.
      </p>
      <p className="indent-8">
        “The first thing I’ve got to do,” said Alice to herself, as
        she wandered about in the wood, “is to grow to my right size again; and
        the second thing is to find my way into that lovely garden. I think that will
        be the best plan.”
      </p>
      <p className="indent-8">
        It sounded an excellent plan, no doubt, and very neatly and simply arranged;
        the only difficulty was, that she had not the smallest idea how to set about
        it; and while she was peering about anxiously among the trees, a little sharp
        bark just over her head made her look up in a great hurry.
      </p>
      <p className="indent-8">
        An enormous puppy was looking down at her with large round eyes, and feebly
        stretching out one paw, trying to touch her. “Poor little thing!”
        said Alice, in a coaxing tone, and she tried hard to whistle to it; but she was
        terribly frightened all the time at the thought that it might be hungry, in
        which case it would be very likely to eat her up in spite of all her coaxing.
      </p>
      <p className="indent-8">
        Hardly knowing what she did, she picked up a little bit of stick, and held it
        out to the puppy; whereupon the puppy jumped into the air off all its feet at
        once, with a yelp of delight, and rushed at the stick, and made believe to
        worry it; then Alice dodged behind a great thistle, to keep herself from being
        run over; and the moment she appeared on the other side, the puppy made another
        rush at the stick, and tumbled head over heels in its hurry to get hold of it;
        then Alice, thinking it was very like having a game of play with a cart-horse,
        and expecting every moment to be trampled under its feet, ran round the thistle
        again; then the puppy began a series of short charges at the stick, running a
        very little way forwards each time and a long way back, and barking hoarsely
        all the while, till at last it sat down a good way off, panting, with its
        tongue hanging out of its mouth, and its great eyes half shut.
      </p>
      <p className="indent-8">
        This seemed to Alice a good opportunity for making her escape; so she set off
        at once, and ran till she was quite tired and out of breath, and till the
        puppy’s bark sounded quite faint in the distance.
      </p>
      <p className="indent-8">
        “And yet what a dear little puppy it was!” said Alice, as she leant
        against a buttercup to rest herself, and fanned herself with one of the leaves:
        “I should have liked teaching it tricks very much, if—if I’d
        only been the right size to do it! Oh dear! I’d nearly forgotten that
        I’ve got to grow up again! Let me see—how <i>is</i> it to be
        managed? I suppose I ought to eat or drink something or other; but the great
        question is, what?”
      </p>
      <p className="indent-8">
        The great question certainly was, what? Alice looked all round her at the
        flowers and the blades of grass, but she did not see anything that looked like
        the right thing to eat or drink under the circumstances. There was a large
        mushroom growing near her, about the same height as herself; and when she had
        looked under it, and on both sides of it, and behind it, it occurred to her
        that she might as well look and see what was on the top of it.
      </p>
      <p className="indent-8">
        She stretched herself up on tiptoe, and peeped over the edge of the mushroom,
        and her eyes immediately met those of a large blue caterpillar, that was
        sitting on the top with its arms folded, quietly smoking a long hookah, and
        taking not the smallest notice of her or of anything else.
      </p>
    </>
  )
}